import LayoutStaticText from './LayoutStaticText';

export default LayoutStaticText;
